import React, { useEffect, useState } from "react";
import axios from "../../axios";
import imageCompression from "browser-image-compression";
import { logEvent } from "../../analytics";
import { EVENTS } from "../../constants/ga-constants";
import "./personalInfo.css";

export default function PersonalInfo() {
  const [originalPersonalInfo, setOriginalPersonalInfo] = useState({});
  const [personalInfo, setPersonalInfo] = useState({});
  const [editRequest, setEditRequest] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [loading, setLoading] = useState(true);
  const [DPLoad, setDPLoad] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);

  const updateUserDetails = _newData => {
    let address = {
      id: _newData.id,
      first_name: _newData.name,
      last_name: _newData.surname,
      phone: _newData.mobileNo,
      phone2: _newData.alterMobileNo,
      email: _newData.emailId,
      flat: _newData.flat,
      apartment: _newData.apartment,
      street: _newData.street,
      locality: _newData.locality,
      city_name: _newData.city,
      state_name: _newData.state,
      zip: _newData.pincode,
      latitude: _newData.latitude,
      longitude: _newData.longitude,
    };
    axios
      .post(`v1/updateUserDetails`, address)
      .then(data => {})
      .catch(err => {});
  };

  useEffect(() => {
    let _userDetails = JSON.parse(localStorage.getItem("userDetails"));
    _userDetails.isAuthenticated && setIsSubscribed(true);
    setUserDetails(() => ({
      profilePic: _userDetails.profilePic,
      Name: _userDetails.Name,
      isAuthenticated: _userDetails.isAuthenticated,
    }));

    axios
      .get(`v1/user`)
      .then(data => {
        data = data.data.data;
        data = {
          id: data.id,
          name: data.first_name,
          surname: data.last_name != null && data.last_name != "undefined" ? data.last_name : "",
          flat: data.flat != null && data.flat != "undefined" ? data.flat : "",
          apartment: data.apartment != null && data.apartment != "undefined" ? data.apartment : "",
          street: data.street != null && data.street != "undefined" ? data.street : "",
          mobileNo: data.phone != null && data.phone != "undefined" ? data.phone : "",
          alterMobileNo: data.phone2 != null && data.phone2 != "undefined" ? data.phone2 : "",
          emailId: data.email != "null" && data.email != "undefined" ? data.email : "",
          state: data.state_name != null && data.state_name != "undefined" ? data.state_name : "",
          city: data.city_name != null && data.city_name != "undefined" ? data.city_name : "",
          locality: data.locality != "undefined" && data.locality != null ? data.locality : "",
          pincode: data.zip != null && data.zip != "undefined" ? data.zip : "",
          latitude: data.latitude != null && data.latitude != "undefined" ? data.latitude : "",
          longitude: data.longitude != null && data.longitude != "undefined" ? data.longitude : "",
          dob: "--/--/----",
        };
        // // console.log(data);
        setPersonalInfo(() => data);
        setOriginalPersonalInfo(() => data);
        setLoading(() => false);
      })
      .catch(err => {
        // console.log(err);
      });
  }, []);

  const handleInputChange = event => {
    const { name, value } = event.target;
    setPersonalInfo(pre => ({
      ...pre,
      [name]: value.replace('"', "'"),
    }));
  };

  const uploadedProfilePic = async e => {
    try {
      let uploadedFile = e.target.files[0];
      if (uploadedFile && uploadedFile.size <= 5 * 1024 * 1024) {
        setDPLoad(true);
        const options = {
          maxSizeMB: 2,
          maxWidthOrHeight: 1920,
        };
        let response = await imageCompression(e.target.files[0], options);

        uploadedFile = new File([response], e.target.files[0].name, {
          lastModified: e.target.files[0].lastModified,
          type: e.target.files[0].type,
        });

        const formData = new FormData();
        formData.append("myImage", uploadedFile);
        const config = {
          headers: {
            "content-type": "multipart/form-data",
          },
        };

        axios
          .post(`v1/profilePic`, formData, config)
          .then(response => {
            setDPLoad(false);
            setUserDetails(pre => {
              return { ...pre, profilePic: response.data.imageUrl };
            });
            logEvent(EVENTS.PROFILE_PIC_UPLOAD.event_name);
          })
          .catch(error => {
            setDPLoad(false);
            alert("Falied to Upload Profile Pic");
          });
      } else {
        alert("Image size should be less than or equal to 5MB");
      }
    } catch (error) {
      alert("Falied to Upload Profile Pic");
    }
  };

  const onInputClick = event => {
    event.target.value = null;
  };

  return personalInfo && !loading ? (
    <form
      className="personal-info--personal-content--wrapper"
      onSubmit={e => {
        e.preventDefault();
        setOriginalPersonalInfo(() => personalInfo);
        updateUserDetails(personalInfo);
        setEditRequest(() => false);
      }}>
      <div className="personal-info--personal-content-1">
        <div className="personal-info--personal-content-1-left">
          <div className="personal-info--personal-content-profilePic-wrapper">
            <div className="tutor-profilePic--wrapper">
              <img
                src={userDetails.profilePic != "null" ? userDetails.profilePic : "./person-icon.png"}
                alt="user profile pic"
                width={window.innerWidth <= 768 ? "60" : "100"}
              />
            </div>
            <div className="showRequest--Edit-btn">
              {personalInfo.mobileNo && !DPLoad ? (
                <form>
                  <label htmlFor="profilePic-1">Upload photo</label>
                  <input
                    id="profilePic-1"
                    type="file"
                    name="myImage"
                    onChange={uploadedProfilePic}
                    onClick={onInputClick}
                    accept=".jpg, .jpeg, .png, .gif"
                    style={{ display: "none" }}
                  />
                </form>
              ) : (
                <form>
                  <label>Uploading</label>
                </form>
              )}
            </div>
          </div>
          <div className="flex align-center">
            <div className="personal-info--personal-content-profile-name">
              {`Hi, ${personalInfo.name} ${personalInfo.surname}`}
            </div>
            {isSubscribed ? (
              <div className="subscribed-badge-container">
                <div className="subscribed-badge">
                  <span className="subscribed-text">Subscribed</span>
                  <span className="verified-icon">
                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M12.9077 6.5V4.92666C12.9077 4.57304 12.7672 4.2339 12.5171 3.98386C12.2671 3.73381 11.928 3.59333 11.5743 3.59333H10.0343L8.941 2.5C8.69119 2.25166 8.35325 2.11227 8.001 2.11227C7.64876 2.11227 7.31082 2.25166 7.061 2.5L6.00101 3.59333H4.42767C4.07405 3.59333 3.73491 3.73381 3.48486 3.98386C3.23481 4.2339 3.09434 4.57304 3.09434 4.92666V6.5L2.001 7.56C1.75267 7.80981 1.61328 8.14775 1.61328 8.5C1.61328 8.85225 1.75267 9.19018 2.001 9.44L3.09434 10.5333V12.0733C3.09434 12.427 3.23481 12.7661 3.48486 13.0161C3.73491 13.2662 4.07405 13.4067 4.42767 13.4067H6.00101L7.061 14.5C7.31082 14.7483 7.64876 14.8877 8.001 14.8877C8.35325 14.8877 8.69119 14.7483 8.941 14.5L10.0343 13.4067H11.5743C11.928 13.4067 12.2671 13.2662 12.5171 13.0161C12.7672 12.7661 12.9077 12.427 12.9077 12.0733V10.5333L14.001 9.44C14.2493 9.19018 14.3887 8.85225 14.3887 8.5C14.3887 8.14775 14.2493 7.80981 14.001 7.56L12.9077 6.5Z"
                        fill="#2196F3"
                      />
                      <path
                        d="M7.50075 10.1667C7.41301 10.1672 7.32604 10.1504 7.24481 10.1172C7.16359 10.084 7.08971 10.0351 7.02742 9.97334L6.00075 8.97334C5.87521 8.8478 5.80469 8.67754 5.80469 8.5C5.80469 8.32247 5.87521 8.1522 6.00075 8.02667C6.12628 7.90113 6.29655 7.83061 6.47408 7.83061C6.65162 7.83061 6.82188 7.90113 6.94742 8.02667L7.47408 8.56L9.00075 7.02667C9.12628 6.89406 9.29936 6.81675 9.48189 6.81175C9.66443 6.80675 9.84147 6.87447 9.97408 7C10.1067 7.12554 10.184 7.29861 10.189 7.48115C10.194 7.66368 10.1263 7.84073 10.0007 7.97334L8.00075 9.97334C7.93532 10.0384 7.8571 10.0892 7.77104 10.1225C7.68497 10.1558 7.59293 10.1708 7.50075 10.1667Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                </div>
              </div>
            ) : (
              <div className="subscribed-badge-container not-subscribed">
                <div className="subscribed-badge not-subscribed">
                  <span className="subscribed-text not-subscribed">Unsubscribed</span>
                  <span className="verified-icon">
                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M12.9077 6.5V4.92666C12.9077 4.57304 12.7672 4.2339 12.5171 3.98386C12.2671 3.73381 11.928 3.59333 11.5743 3.59333H10.0343L8.941 2.5C8.69119 2.25166 8.35325 2.11227 8.001 2.11227C7.64876 2.11227 7.31082 2.25166 7.061 2.5L6.00101 3.59333H4.42767C4.07405 3.59333 3.73491 3.73381 3.48486 3.98386C3.23481 4.2339 3.09434 4.57304 3.09434 4.92666V6.5L2.001 7.56C1.75267 7.80981 1.61328 8.14775 1.61328 8.5C1.61328 8.85225 1.75267 9.19018 2.001 9.44L3.09434 10.5333V12.0733C3.09434 12.427 3.23481 12.7661 3.48486 13.0161C3.73491 13.2662 4.07405 13.4067 4.42767 13.4067H6.00101L7.061 14.5C7.31082 14.7483 7.64876 14.8877 8.001 14.8877C8.35325 14.8877 8.69119 14.7483 8.941 14.5L10.0343 13.4067H11.5743C11.928 13.4067 12.2671 13.2662 12.5171 13.0161C12.7672 12.7661 12.9077 12.427 12.9077 12.0733V10.5333L14.001 9.44C14.2493 9.19018 14.3887 8.85225 14.3887 8.5C14.3887 8.14775 14.2493 7.80981 14.001 7.56L12.9077 6.5Z"
                        fill="#6B7280"
                      />
                      <path
                        d="M7.50075 10.1667C7.41301 10.1672 7.32604 10.1504 7.24481 10.1172C7.16359 10.084 7.08971 10.0351 7.02742 9.97334L6.00075 8.97334C5.87521 8.8478 5.80469 8.67754 5.80469 8.5C5.80469 8.32247 5.87521 8.1522 6.00075 8.02667C6.12628 7.90113 6.29655 7.83061 6.47408 7.83061C6.65162 7.83061 6.82188 7.90113 6.94742 8.02667L7.47408 8.56L9.00075 7.02667C9.12628 6.89406 9.29936 6.81675 9.48189 6.81175C9.66443 6.80675 9.84147 6.87447 9.97408 7C10.1067 7.12554 10.184 7.29861 10.189 7.48115C10.194 7.66368 10.1263 7.84073 10.0007 7.97334L8.00075 9.97334C7.93532 10.0384 7.8571 10.0892 7.77104 10.1225C7.68497 10.1558 7.59293 10.1708 7.50075 10.1667Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="personal-info--personal-content-1-right">
          {!editRequest ? (
            <div
              onClick={() => {
                setEditRequest(() => true);
              }}
              style={{
                cursor: "pointer",
                width: "50px",
                margin: "0 0 0 auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
              }}>
              <span className="edit-txt">Edit</span>
              <img src="/pencil-icon.svg" alt="pencil-icon" width="15" height="15" />
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
      <div className={`personal-info--personal-content-2 ${editRequest ? "editInput" : ""}`}>
        <div className="personal-info--personal-content--field-wrapper">
          <div className="personal-info--personal-content-subtitle">
            <img src="/user-profile-focus.svg" alt="user-profile-focus" width="15" height="15" />
            First Name
          </div>
          <div className="personal-info--personal-content-data">
            <input
              type="text"
              readOnly={!editRequest}
              name="name"
              onChange={handleInputChange}
              value={personalInfo.name}
            />
          </div>
        </div>
        <div className="personal-info--personal-content--field-wrapper">
          <div className="personal-info--personal-content-subtitle">
            <img src="/user-profile-focus.svg" alt="user-profile-focus" width="15" height="15" />
            Last Name
          </div>
          <div className="personal-info--personal-content-data">
            <input
              type="text"
              readOnly={!editRequest}
              name="surname"
              onChange={handleInputChange}
              value={personalInfo.surname}
            />
          </div>
        </div>
        <div className="personal-info--personal-content--field-wrapper">
          <div className="personal-info--personal-content-subtitle">
            <img src="/user-profile-focus.svg" alt="user-profile-focus" width="15" height="15" />
            Mobile No
          </div>
          <div className="personal-info--personal-content-data">
            <input
              type="text"
              readOnly={editRequest}
              name="mobileNo"
              onChange={handleInputChange}
              value={personalInfo.mobileNo}
            />
          </div>
        </div>
        <div className="personal-info--personal-content--field-wrapper">
          <div className="personal-info--personal-content-subtitle">
            <img src="/user-profile-focus.svg" alt="user-profile-focus" width="15" height="15" />
            Alter Mobile No
          </div>
          <div className="personal-info--personal-content-data">
            <input
              type="text"
              readOnly={!editRequest}
              name="alterMobileNo"
              onChange={handleInputChange}
              value={personalInfo.alterMobileNo}
            />
          </div>
        </div>
        <div className="personal-info--personal-content--field-wrapper">
          <div className="personal-info--personal-content-subtitle">
            <img src="/calender.svg" alt="calender.svg" width="15" height="15" />
            DOB
          </div>
          <div className="personal-info--personal-content-data">
            <input
              type="date"
              readOnly={!editRequest}
              name="dob"
              onChange={handleInputChange}
              value={personalInfo.dob}
              max={new Date().toISOString().split("T")[0]}
            />
          </div>
        </div>
        <div className="personal-info--personal-content--field-wrapper">
          <div className="personal-info--personal-content-subtitle">
            <img src="/user-profile-focus.svg" alt="user-profile-focus" width="15" height="15" />
            Email Id{" "}
          </div>
          <div className="personal-info--personal-content-data">
            <input
              type="email"
              readOnly={!editRequest}
              name="emailId"
              onChange={handleInputChange}
              value={personalInfo.emailId}
            />
          </div>
        </div>
        {/* <div className='personal-info--personal-content--field-wrapper'>
                        <div className='personal-info--personal-content-subtitle'>
                          <img src="/user-profile-focus.svg" alt="user-profile-focus" width="15" height="15"/>
                          Date Of Birth</div>
                        <div className='personal-info--personal-content-data'>
                          <input type='text' readOnly={!editRequest} name='dob' onChange={handleInputChange} value= {personalInfo.dob}/>
                          </div>
                    </div> */}
      </div>

      {editRequest ? (
        <div className="showRequest-Save-cancel-wrapper">
          <div
            onClick={() => {
              setPersonalInfo(() => originalPersonalInfo);
              setEditRequest(() => false);
            }}
            className="showRequest-Save-wrapper showRequest-cancel-wrapper">
            <button type="button">Cancel</button>
          </div>
          <div className="showRequest-Save-wrapper">
            <button type="submit">Save</button>
          </div>
        </div>
      ) : (
        <></>
      )}
    </form>
  ) : (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "80vh",
      }}>
      <div className="loading">
        <img src="./book-loader.gif" alt=" Loading . . .  " />
      </div>
    </div>
  );
}
